import React from 'react';
import { useCollections } from '../../hooks/useShopify'; // New hook
import { Skeleton } from "@/components/ui/skeleton";
import { Link } from 'react-router-dom';

const CategoryGrid = () => {
  const { collections, loading, error } = useCollections();

  if (error) {
    return <div className="text-center py-10 text-destructive">Kunne ikke laste kategorier. Prøv igjen senere.</div>;
  }

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary mb-4">Hva leter du etter i dag?</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Hos oss finner du alt fra hardføre stauder til vakre inneplanter.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {loading ? (
            // Skeleton Loading State
            Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="flex flex-col items-center gap-4">
                <Skeleton className="w-32 h-32 md:w-40 md:h-40 rounded-full" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-24 mx-auto" />
                  <Skeleton className="h-3 w-16 mx-auto" />
                </div>
              </div>
            ))
          ) : (
            // Data Loaded
            collections.map((cat) => (
              <Link 
                key={cat.id} 
                to={`/category/${cat.handle || cat.name.toLowerCase().replace(/ /g, '-').replace(/&/g, 'og')}`}
                className="group flex flex-col items-center gap-4 text-center cursor-pointer"
              >
                <div className="relative w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden shadow-lg border-4 border-white group-hover:border-accent transition-all duration-300 group-hover:shadow-xl">
                  <img 
                    src={cat.image} 
                    alt={cat.name} 
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=400&auto=format&fit=crop'; }}
                  />
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground text-lg group-hover:text-primary transition-colors">{cat.name}</h3>
                  <p className="text-xs text-muted-foreground mt-1">{cat.count}</p>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
